export default [
  {
    Companies: [
      {
        fileName: "login/companii/vn-dejun2.png",
        link: "https://upromania.ro/companii/card-de-tichete-de-masa-up-dejun/",
        category: "Banner",
        action: "Click",
        label: "Client_vn_dejun_45",
      },
    ],
    Beneficiaries: [
      {
        fileName: "login/utilizatori/banner_mobilplus.png",
        link:
          "https://upromania.page.link/ump",
        category: "Banner",
        action: "Click",
        label: "Utilizatori_mobilplus",
      },
    ],
  },
];
